// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import {
	type DefaultMessagesResponse,
	type PlacementMessageFrontendFactory,
	type AnyProps,
	type NoProps,
	type PlacementRenderer,
	type AnyFrontendStage,
	type PlacementBrowserConfig,
} from '@post-office/message-maker-browser/types';

import { createPlacementFrontend } from '@post-office/message-maker-browser/create-placement-frontend';

import { usePlacementApi } from '@post-office/use-placement-api';

import { type PropsWithChildren } from 'react';

const placementConfig: PlacementBrowserConfig = {
	placementId: 'jira-filter-refinement-filter-button',
	options: {
		choreographer: {
			isDefaultEnabled: false,
		},
	},
};

const placement = {
	createFrontend: createPlacementFrontend(placementConfig),
};

export const createFrontend: <U extends AnyProps = NoProps>(
	placementRenderer: PlacementRenderer<
		{
			render: AnyFrontendStage;
		},
		U
	>,
) => PlacementMessageFrontendFactory<
	{
		render: AnyFrontendStage;
	},
	U
> = placement.createFrontend;

export type PlacementFrontendProps = {
	view?: 'backlog' | 'list';
} & PropsWithChildren;

export const PlacementFrontend: PlacementMessageFrontendFactory<
	{
		render: AnyFrontendStage;
	},
	PlacementFrontendProps
> = createFrontend<PlacementFrontendProps>((Messages) => ({ children, view }) => {
	const { data, error, isLoading } = usePlacementApi<DefaultMessagesResponse>(
		'/',
		view
			? {
					queryParams: {
						view,
					},
				}
			: undefined,
	);

	if (!children) {
		return null;
	}

	if (error || isLoading || data.messages.length === 0) {
		return <>{children}</>;
	}

	const [message] = data.messages;

	return <Messages.render {...message}>{children}</Messages.render>;
});
